<script setup lang="ts">
import type {
  PeriodDurationInquiry,
  PayloadTracking,
} from '~/types/inquiry/types'
import type { HouseDetails } from '~/types/house/types'

const { booking, setStep } = useHouseInquiryBooking()

withDefaults(
  defineProps<{
    bookingSent?: boolean
    house: HouseDetails
    logout: () => void
    payloadTracking: PayloadTracking
    periods: PeriodDurationInquiry[]
    isBooking?: boolean
    showCalendar?: boolean
  }>(),
  {
    bookingSent: false,
    isBooking: false,
    showCalendar: false,
  },
)

const emits = defineEmits<{
  'hide-calendar': []
  'close-inquiry': []
}>()

const isLoading = ref(false)

const onLoading = (value: boolean) => {
  isLoading.value = value
}

onMounted(() => {
  setStep(0)
})
</script>

<template>
  <div
    :class="[
      'inquiry-block__loader',
      { visible: isLoading, invisible: !isLoading },
    ]"
  />

  <LazyInquiryDatePickerStep
    v-if="booking.currentStep === 0"
    data-testid="inquiry-block__step"
    :booking-sent="bookingSent"
    :house="house"
    :payload-tracking="payloadTracking"
    :periods="periods"
    :is-booking="isBooking"
    :show-calendar="showCalendar"
    @close-inquiry="emits('close-inquiry')"
    @loading="onLoading"
    @hide-calendar="emits('hide-calendar')"
  />

  <LazyInquiryFormStep
    v-else-if="booking.currentStep === 1"
    data-testid="inquiry-block__step"
    :house="house"
    :logout="logout"
    :payload-tracking="payloadTracking"
    @loading="onLoading"
  />
  <LazyInquirySuccessStep
    v-else-if="booking.currentStep === 2"
    data-testid="inquiry-block__step"
    :house="house"
    @loading="onLoading"
  />
</template>

<style>
.inquiry-block__loader {
  @apply absolute inset-0 overflow-hidden z-10;
  background: linear-gradient(-65deg, #fffd 37%, #fff0 50%, #fffd 62%);
  background-size: 500% 500%;
  animation: Gradient 2s linear infinite;
}
</style>
